module.exports = __webpack_public_path__ + "resources/feature-icon-8-a46f298568f006ee12854ae7141b5d6d.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-8.png
// module id = 72
// module chunks = 0